import { useEffect, useRef } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { authApi } from '../../api/endpoints/auth';
import { handleApiError } from '../../api/errorMapping';
import { LoadingSpinner } from '../shared/LoadingSpinner';

interface Props {
    email: string;
    tempPassword: string;
}

export function ActivateAccount({ email, tempPassword }: Props) {
    const { t } = useTranslation(['auth']);
    const navigate = useNavigate();
    const firedRef = useRef(false);

    const mutation = useMutation({
        mutationFn: () => authApi.login({ email, password: tempPassword }),
        onSuccess: async (resp) => {
            if (resp.status === 'CHALLENGE' && resp.challengeType === 'NEW_PASSWORD_REQUIRED') {
                await navigate({
                    to: '/login/new-password',
                    search: { session: resp.session },
                });
            } else {
                await navigate({ to: '/' });
            }
        },
        onError: (err) => {
            handleApiError(err);
            void navigate({ to: '/login' });
        },
    });

    useEffect(() => {
        if (firedRef.current) return;
        firedRef.current = true;
        mutation.mutate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <LoadingSpinner label={t('auth:activating')} size="lg" />;
}
